import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Briefcase, ArrowRight } from 'lucide-react';
import { peekReturnTo, peekReturnToLabel, clearReturnTo } from '../lib/returnTo';

// "Continue your application" card. A visitor who tapped Apply on a job, signed
// up with Facebook/Google, and finished onboarding is normally sent straight back
// to that job. This card is the safety net for anyone who still lands here with a
// live remembered job (e.g. an already-complete account). Read-only peek: it only
// clears the intent when the visitor actually clicks through.
// Also shown on the profile page: the apply pop-up's "add work experience" link sends the
// seeker there with the job remembered (and the draft saved), and this is their way back.
const ContinueApplicationCard = ({ navigate, t }) => {
  const target = peekReturnTo();
  // Only surface an actual application target, never a bare /dashboard etc.
  if (!target || !(target.startsWith('/jobs/') || target.startsWith('/gigs/'))) return null;
  const label = peekReturnToLabel();

  const go = () => {
    clearReturnTo();
    navigate(target);
  };

  return (
    <Card className="bg-gradient-to-r from-primary/10 to-primary/5 border-primary/30 card-enhanced">
      <CardContent className="p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="flex items-start gap-3 min-w-0">
            <Briefcase className="text-primary flex-shrink-0 mt-0.5" size={22} />
            <div className="min-w-0">
              <h2 className="font-heading text-base sm:text-lg font-semibold">
                {t('dashboard.continueApplicationTitle', 'Continue your application')}
              </h2>
              <p className="text-sm text-muted-foreground truncate">
                {label
                  ? t('dashboard.continueApplicationTo', { defaultValue: 'Finish applying to {{title}}', title: label })
                  : t('dashboard.continueApplicationGeneric', 'Pick up where you left off')}
              </p>
            </div>
          </div>
          <Button className="rounded-xl w-full sm:w-auto flex-shrink-0" onClick={go}>
            {t('dashboard.continueApplicationCta', 'Continue')}
            <ArrowRight size={16} className="ml-2" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ContinueApplicationCard;
